export default __webpack_public_path__ + "static/media/pavers-steps-nice.cde89ea8.jpg";